import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';
import { ConfigService } from '@cue-admin/config';

@Directive({
  selector: 'kendo-panelbar[appAnalyticsHide], li[appAnalyticsHide]',
  standalone: true,
})
export class AnalyticsDirective implements AfterViewInit {
  private readonly configService = inject(ConfigService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly appAnalyticsHide = input<boolean | '' | undefined>(undefined);

  ngAfterViewInit(): void {
    if (this.appAnalyticsHide() !== false) {
      if (!this.configService.value?.analytics) {
        this.elementRef.nativeElement.style.setProperty('display', 'none', 'important');
      }
    }
  }
}
